/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * <pre><code>Represents the actions performed on report
 * UPLOAD - ReportUpload
 * DOWNLOAD - ReportDownload
 * CREATE_FOLDER - ReportFolder creation
 * <\/code><\/pre>
 **/
export var ReportAction;
(function (ReportAction) {
    ReportAction["UPLOAD"] = "UPLOAD";
    ReportAction["DOWNLOAD"] = "DOWNLOAD";
    ReportAction["CREATE_FOLDER"] = "CREATE_FOLDER";
})(ReportAction || (ReportAction = {}));
